import * as React from 'react'
import { selectAllOpportunities } from '@user/store/opportunity/slice'
import { useSelector } from 'react-redux'
import { useGetColumnData } from './useGetColumnData'
import { OpportunityList } from './OpportunityList'
import { OppListProviderProps } from '../typings'

export const OpportunityListProvider: React.FC<OppListProviderProps> = ({
  loading: oppsLoading,
  page,
  ...props
}) => {
  const rows = useSelector(selectAllOpportunities)
  const { loading: colsLoading, columns, columnVisibility } = useGetColumnData()

  return (
    <OpportunityList
      {...props}
      page={colsLoading ? 1 : page}
      loading={colsLoading || oppsLoading}
      columns={colsLoading ? [] : columns}
      columnVisibility={columnVisibility}
      rows={colsLoading ? [] : rows}
    />
  )
}
OpportunityListProvider.displayName = 'OpportunityListProvider'
